import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vuldb = defineConnector({
  identifier: "vuldb",
  name: "VulDB",
  tagLine: "Vulnerability intelligence database",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://vuldb.com/.*",
  auth: (app) => queryAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Collect the required credentials for VulDB",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://vuldb.com/kb/api](https://vuldb.com/kb/api) to create the credential values this API expects on each request.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://vuldb.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://vuldb.com/?api")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
